import { FilterDef } from "@/stores/filters/FilterDef";

export class OrganisationFilterDef extends FilterDef {

	/**
	 * Constructor
	 */
	constructor() {

		super([
			'query',
			'subscription_plan',
			'subscription_type',
			'country',
			'expired',
			'type',
			'school_group_id',
			'curriculum'
		]);

	}


	get query(): string | null {
		return this.getParamValues('query')[0]?.id || null;
	}

	set query(value: string) {
		this.setParamValue('query', value);
	}

	get subscriptionPlan(): string | null {
		return this.getParamValues('subscription_plan')[0]?.id || null;
	}

	set subscriptionPlan(value: string) {
		if (!value) {
			this.clearParam('subscription_plan');
			return;
		}
		this.setParamValue('subscription_plan', value);
	}

	get subscriptionType(): string | null {
		return this.getParamValues('subscription_type')[0]?.id || null;
	}

	set subscriptionType(value: string) {
		if (!value) {
			this.clearParam('subscription_type');
			return;
		}
		this.setParamValue('subscription_type', value);
	}

	get country(): string | null {
		return this.getParamValues('country')[0]?.id || null;
	}

	set country(value: string) {
		if (!value) {
			this.clearParam('country');
			return;
		}
		this.setParamValue('country', value);
	}

	get expired(): boolean | null {
		const value = this.getParamValues('expired')[0]?.id;
		if (value === undefined) {
			return null;
		}
		return !!value;
	}

	set expired(value: boolean) {
		if (value === null) {
			this.clearParam('expired');
			return;
		}

		this.setParamValue('expired', value);
	}

	get type(): string | null {
		return this.getParamValues('type')[0]?.id || null;
	}

	set type(value: string) {
		if (!value) {
			this.clearParam('type');
			return;
		}
		this.setParamValue('type', value);
	}

	get schoolGroupId(): string | null {
		return this.getParamValues('school_group_id')[0]?.id || null;
	}

	set schoolGroupId(value: string) {
		if (!value) {
			this.clearParam('school_group_id');
			return;
		}
		this.setParamValue('school_group_id', value);
	}

	get curriculum(): string | null {
		return this.getParamValues('curriculum')[0]?.id || null;
	}

	set curriculum(value: string) {
		if (!value) {
			this.clearParam('curriculum');
			return;
		}
		this.setParamValue('curriculum', value);
	}

}
